import { NavLink, useLocation } from 'react-router-dom';
import { AccountMultipleIcon, CalendarIcon, HouseChimneyIcon, KeyIcon, LocationDotIcon } from '@c2fo/liquidity/icons';
import { ProfileSelect } from '../ProfileSelect';
import { DataRegionSelect } from '../DataRegionSelect';
import { SettingsMenu } from '../SettingsMenu';

const baseClasses =
  'flex items-center gap-2 px-4 py-3 text-sm font-medium transition-all duration-200 relative hover:bg-gray-100 active:scale-95 active:bg-gray-200';
const inactiveClasses = 'text-muted-foreground hover:text-foreground';
const activeClasses = 'text-foreground border-b-2 border-green-500 pointer-events-none';

const getNavLinkClasses = ({ isActive }: { isActive: boolean }) =>
  `${baseClasses} ${isActive ? activeClasses : inactiveClasses}`;

export const FileDeliveryNavigation: React.FC = () => {
  const location = useLocation();
  const isAccountsRoute = location.pathname === '/file-delivery/serviceAccounts';

  return (
    <div className="border-b border-border bg-background">
      <div className="flex items-center justify-between px-4">
        <nav className="flex items-center gap-1">
          <NavLink to="/file-delivery/deliveries" className={getNavLinkClasses}>
            <HouseChimneyIcon fill="black" /> Deliveries
          </NavLink>
          <NavLink to="/file-delivery/locations" className={getNavLinkClasses}>
            <LocationDotIcon /> Locations
          </NavLink>
          <NavLink to="/file-delivery/credentials" className={getNavLinkClasses}>
            <KeyIcon /> Credentials
          </NavLink>
          <NavLink to="/file-delivery/scheduledDeliveries" className={getNavLinkClasses}>
            <CalendarIcon /> Schedules
          </NavLink>
          <NavLink to="/file-delivery/serviceAccounts" className={getNavLinkClasses}>
            <AccountMultipleIcon /> Accounts
          </NavLink>
        </nav>
        <div className="flex items-center gap-2">
          <DataRegionSelect />
          {!isAccountsRoute && <ProfileSelect />}
          <SettingsMenu />
        </div>
      </div>
    </div>
  );
};
